import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PipesModule } from '../pipes/pipes.module';
import { InitNavbarComponent } from './init-navbar/init-navbar.component';
import { InitFooterComponent } from './init-footer/init-footer.component';



@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    InitNavbarComponent,
    InitFooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    InitNavbarComponent,
    InitFooterComponent,
  ],
})
export class SharedModule { }